var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ErrorCloud50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M47.9,30.55C47.19,35.47,42.79,39,37.87,39H10.14c-4.93,0-9.33-3.53-10.04-8.45 c-0.87-6.14,3.82-11.4,9.73-11.4c0.04,0,0.08,0.01,0.12,0.01C11.94,13.25,17.47,9,24,9c4.62,0,8.75,2.13,11.46,5.47 c1.1,1.34,1.96,2.87,2.53,4.54c0.03,0.05,0.04,0.1,0.06,0.15c0.04,0,0.08-0.01,0.12-0.01C44.08,19.15,48.77,24.42,47.9,30.55z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 22,
    y: 15,
    fill: "#2100c4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 22,
    y: 30,
    fill: "#2100c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ErrorCloud50);
export default __webpack_public_path__ + "static/media/icons8-error-cloud-50.7d0a6be3c87901d22f2333cd212e732b.svg";
export { ForwardRef as ReactComponent };